import { Controller } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";
import Select from "react-select";
import classNames from "classnames";

import * as actions from "../store/actions/index";
import { useEffect } from "react";

export const SelectBlockChain = ({
  setContractDetails,
  watch,
  getValues,
  control,
  errors,
  contract = "",
}) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const { payments } = useSelector((state) => state.paymentGateway);
  const blockchainOption = payments.filter(Boolean).map((option) => ({
    value: option.chainId,
    label: option.title,
  }));

  useEffect(() => {
    dispatch(actions.getPaymentGateway("crypto-payment"));
  }, [dispatch]);

  useEffect(() => {
    if (watch("chainId") || getValues("chainId")) {
      const currentChain = payments.find(
        (payment) => payment.chainId === watch("chainId").value
      );

      if (currentChain) {
        setContractDetails({
          address:
            contract === "tokenization"
              ? currentChain.tokenizationContractAddress
              : currentChain.contractAddress,
          chainId: watch("chainId").value,
        });
      }
    }
  }, [watch("chainId"), getValues("chainId")]);

  return (
    <div className="col-md-12 form-group floating-input-field-wrapper mb-2">
      <label className="floating-input-field-label-static">
        {intl.formatMessage({
          id: "BLOCKCHAIN.SELECT",
        })}
        <span className="text-danger">*</span>
      </label>
      <Controller // Use Controller for Select
        control={control}
        name="chainId"
        defaultValue={blockchainOption[0]}
        rules={{ required: true }}
        render={({ field }) => (
          <Select
            {...field}
            isSearchable={false}
            placeholder={intl.formatMessage({
              id: "BLOCKCHAIN.SELECT",
            })}
            options={blockchainOption}
            classNamePrefix="react-select"
            className={classNames({
              "is-invalid": errors.chainId,
            })}
          />
        )}
      />
    </div>
  );
};
